import useLang from "../../../hooks/useLang";
import { useLocation } from "react-router-dom";

const useAssessmentPageBlock = ({ assessments, organisationId }) => {
  const lang = useLang();
  const location = useLocation();

  let reportsFound = false;
  let analysesFound = false;

  const data = assessments?.data?.map((assessment, idx) => {
    if (Array.isArray(assessment?.reports) && assessment?.reports?.length > 0) {
      reportsFound = true;
    }
    if (
      Array.isArray(assessment?.analyses) &&
      assessment?.analyses?.length > 0
    ) {
      analysesFound = true;
    }
    return {
      ...assessment,
      user: {
        ...assessment?.user,
        full_name: `${assessment?.user?.given_name} ${assessment?.user?.family_name}`,
      },
      participant: {
        ...assessment?.participant,
        gender: lang(`captions.${assessment?.participant?.gender}_short`),
      },
      analysis_summary: assessment?.analyses
        ?.map(
          (analysis) =>
            lang(`analyses.${analysis.state}`) +
            " (" +
            analysis?.date_created?.split(" ")[0] +
            ")"
        )
        ?.join(", "),
    };
  });

  const config = [];
  if (organisationId != null) {
  }
  config.push({
    id: "date_created",
    header: { title: lang("assessments.assessment_date") },
    link: (data) => `${location?.pathname}/${data?.id}`,
    width: 56,
  });

  if (organisationId == null) {
    config.push({
      id: "organisation.name",
      header: { title: lang("organisations.organisation") },
      width: 48,
    });
  }

  config.push({
    id: "participant.iid",
    width: 32,
  });

  config.push({
    id: "participant.date_of_birth",
    width: 32,
  });

  config.push({
    id: "participant.gender",
    width: 16,
  });
  config.push({
    id: "user.full_name",
    header: { title: lang("common.carried_out_by") },
    width: 72,
  });
  if (reportsFound) {
    config.push({
      id: "reports.id",
      header: { title: lang("reports.title") },
      linkList: (rowData) => {
        const reportLinks = rowData?.reports?.map((report) => ({
          id: report?.id,
          to: report?.url,
          caption: report?.date_created?.split(" ")[0],
          icon:
            report?.state === "FINISHED"
              ? "assessment"
              : report?.state === "ERROR"
              ? "exclamation"
              : "refresh",
          target: "_blank",
          disabled: report?.state !== "FINISHED",
        }));
        return reportLinks;
      },
      width: 48,
    });
  }
  if (analysesFound && !reportsFound) {
    config.push({
      id: "analysis_summary",
      header: { title: lang("analyses.title") },
      linkList: (rowData) => {
        const analysisLinks = rowData?.analyses?.map((analysis) => ({
          id: analysis?.id,
          to: `${location?.pathname}/${rowData?.id}/analyses/${analysis?.id}`,
          icon: analysis?.state === "FEATURE_SELECTION" ? "features" : "list",
          caption: analysis?.date_created?.split(" ")[0],
        }));
        return analysisLinks;
      },
      width: 48,
    });
  }

  const items = [
    {
      id: "assessmentTable",
      type: "table",
      data: data,
      config,
    },
  ];

  return items;
};

export default useAssessmentPageBlock;
